
const onDialogueStateInit = async (neuroState) => {
    const defaultPrimaryColor = "#f18c24";
    const defaultSecondaryColor = "#0c5c5c";
    if( window?.ignite?.userService?.getGuideAttributes ) {
        const guideAttributes = await window.ignite.userService.getGuideAttributes();
        const primaryColor = guideAttributes?.uiConfig?.cssConfig?.palette?.contextual?.primary?.defaultColor || defaultPrimaryColor;
        const secondaryColor = guideAttributes?.uiConfig?.cssConfig?.palette?.contextual?.secondary?.defaultColor || defaultSecondaryColor;
        const isFdicMember = guideAttributes?.fdic || false;
        const isEhlMember = guideAttributes?.ehl || false;
        const hideActions = guideAttributes?.hideActions || false;
        return {
            ...neuroState,
            isFdicMember,
            isEhlMember,
            hideActions,
            themeColors: {
                primaryColor,
                secondaryColor
            }
        }
    } else {
        return {
            ...neuroState,
            isFdicMember: false,
            themeColors: {
                primaryColor: defaultPrimaryColor,
                secondaryColor: defaultSecondaryColor
            }
        }
    }
}

export default onDialogueStateInit;
